/**
 * Styles aligned with Figma "Export Main Copy" (11929:251564)
 * Uses CSS variables from window/theme context where available.
 */
const exportAllWithEmailStyles = (theme) => ({
    /* Container: matches .export-main-copy – 532px, gap 12px, padding-bottom 24px */
    mainCopy: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        boxSizing: 'border-box',
        minHeight: 85,
        paddingBottom: 'var(--export-padding-bottom, 24px)',
        gap: 'var(--export-spacing-gap, 12px)',
        backgroundColor: 'var(--white, #ffffff)',
        maxHeight: '70vh',
        overflowY: 'auto',
    },
    /* Section title: Orijin/overline/large – Rubik 500, 18px, 21.33px line-height, 1.8px letter-spacing */
    sectionTitle: {
        fontFamily: 'var(--export-title-font, var(--font-main, "Rubik"), sans-serif)',
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: 18,
        lineHeight: '21.33px',
        letterSpacing: '1.8px',
        textTransform: 'uppercase',
        color: 'var(--cerulean-main, var(--export-title-color, #0078a2))',
        textAlign: 'left',
        width: '100%',
        margin: 0,
    },
    /* Body: Orijin/body/large – Inter 400, 16px, 24px line-height, 0.32px letter-spacing */
    sectionBody: {
        fontFamily: 'var(--export-body-font, "Inter", sans-serif)',
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: '0.32px',
        color: 'var(--grey-110, var(--export-body-color, #333333))',
        textAlign: 'left',
        width: '100%',
        margin: 0,
    },
    section: {
        width: '100%',
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--export-spacing-gap, 12px)',
    },
    emailInput: {
        width: '100%',
        marginBottom: 12,
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
        },
    },
    addEmailButton: {
        borderColor: 'var(--aqua-deep)',
        color: 'var(--aqua-deep)',
        fontWeight: 700,
        padding: '6px 20px',
        fontSize: 16,
        textTransform: 'capitalize',
        minHeight: 40,
        '& .MuiButton-startIcon': {
            color: 'inherit',
        },
    },
    passwordInput: {
        width: '100%',
        marginBottom: 8,
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            paddingLeft: 0,
        },
        '& .MuiInputAdornment-root': {
            marginLeft: theme.spacing(1.5),
        },
    },
    /* Helper text: secondary grey */
    passwordHelper: {
        fontFamily: 'var(--export-body-font, "Inter", sans-serif)',
        color: 'var(--grey-100, #757575)',
        fontSize: 12,
        lineHeight: 1.5,
        marginTop: 4,
        margin: 0,
    },
    mainWrapper: {
        '& .modal-footer div': {
            flexFlow: 'row-reverse',
        },
    },
});

export default exportAllWithEmailStyles;

export const ExportModalStyles = (theme) => ({
    '& .modal-footer div': {
        flexFlow: 'row-reverse',
        gap: 10
    },
});

